import Icon from './Icon';
export default Icon;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-icon/src/index.js